module.exports = __webpack_public_path__ + "img/doubt_man.ef392619.png";